import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { getJwtToken } from '../../auth'
import { classroomDocsQueryApi, classroomZoomQueryApi, studentClassroomQueryApi } from '../../react-query/queryApis'

interface IStudentClassroom {
  data: any
}
interface IError {
  error: string
}

export const useStudentClassroom = (lessonId: string) => {
  const pathParams = { lessonId }
  const token = getJwtToken()
  return useQuery<IStudentClassroom, AxiosError<IError>>({
    queryKey: studentClassroomQueryApi.getQueryKey({ pathParams }),
    queryFn: studentClassroomQueryApi.getQueryFn({ pathParams }),
    refetchOnWindowFocus: false,
    // enabled: !!token,
    // onError: (e) => handleAxiosError(e),
  })
}

interface IZoomData {
  zoom_url: string
  join_url: string
  meeting_number: string
}
export const useClassroomZoom = (lessonId: string) => {
  const pathParams = { lessonId }
  const token = getJwtToken()
  return useQuery<IZoomData, AxiosError<IError>>({
    queryKey: classroomZoomQueryApi.getQueryKey({ pathParams }),
    queryFn: classroomZoomQueryApi.getQueryFn({ pathParams }),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    // enabled: !!token,
    // onError: (e) => handleAxiosError(e),
  })
}
interface IDocsData {
  document_url: string
  ringledoc_url: string
  ringledoc: string
}
export const useClassroomDocs = (lessonId: string) => {
  const pathParams = { lessonId }
  const token = getJwtToken()
  return useQuery<IDocsData, AxiosError<IError>>({
    queryKey: classroomDocsQueryApi.getQueryKey({ pathParams }),
    queryFn: classroomDocsQueryApi.getQueryFn({ pathParams }),
    refetchOnWindowFocus: false,
    // enabled: !!token,
    // onError: (e) => handleAxiosError(e),
  })
}
